module.exports = __webpack_public_path__ + "static/media/icon_statement.00f0e329.svg";